/* 🤖 this file was generated by svg-to-ts */
export const DfIconHeartSquare16: {
  name: 'heart-square-16';
  data: string;
} = {
  name: 'heart-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm-2.58 5.803c-.833-.997-2.26-.931-3.185-.032L8 6l-.254-.243c-.931-.89-2.353-.943-3.179.061-.825 1.005-.74 2.54.192 3.43l2.547 2.457a1 1 0 0 0 1.388 0l2.562-2.47c.924-.899.997-2.436.164-3.432z"/></svg>`
};
